
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMUser } from "@/store";

import ComplianceProfile from "@/modules/Compliance/Profile/ComplianceProfile.vue";

const TYPE_COMPLIANCE_PROFILE = "complianceProfile";

@Component({
  components: { ComplianceProfile },
})
export default class EmployerCompanySponsorLicence extends Vue {
  type = TYPE_COMPLIANCE_PROFILE;

  loading = false;

  async fetchSLCaseId(): Promise<void> {
    try {
      this.loading = true;

      const { data } = await this.axios.get<number>(API_ROUTES.COMPANY_SL);

      if (!data) return;

      await this.openService(data);
    } finally {
      this.loading = false;
    }
  }

  async openService(serviceId: number) {
    if (!serviceId) return;

    await this.$router.push(`/cases/${serviceId}/dashboard/16`);
  }

  get isSLStarted() {
    return SMUser.isSLStarted;
  }
}
